import { createContext, useContext } from "react";

interface RowHeightContextValue {
  updateRowHeight: (
    clientId: string,
    rowIndex: number,
    explicitHeight?: number,
  ) => void;
  getManualHeight: (clientId?: string) => number | undefined;
}

export const RowHeightContext = createContext<RowHeightContextValue>({
  updateRowHeight: () => {},
  getManualHeight: () => undefined,
});

export const useRowHeight = () => useContext(RowHeightContext);
